<template>
  <div class="duty-schedule text-dark">
    <transition name="fadeOut">
      <DoSplash v-if="isInitialLoading"></DoSplash>
    </transition>
    <div class="do-wrapper">
      <WeekSelecter
        :date="date"
        :startDate="schoolYear.employee_time_start"
        :endDate="schoolYear.employee_time_end"
        @changed="setDate($event)">
      </WeekSelecter>
      <DutySchedulePlan
        :theCreateEventObj="theCreateEventObj"
        :usersCalIdsHash="allUsersInCalIdHash"
        :calendars="kindergartenCalendars"
        :isEventsLoading="isEventsLoading"
        :date="date"
        :events="events"
        :eventsInHash="eventsInUserCalendarIdHash"
        :userNorms="userNorms"
        :theNewlyCreatedSubject="theNewlyCreatedSubject"
        :schoolSettings="schoolSettings"
        :isCreateOpeningHours="isCreateOpeningHours"
        :openingHours="openingHours"
        @createSubject="onCreateSubject"
        @createEvent="onCreateEvent"
        @editEvent="onEditEvent"
        @setIsCreateOpeningHours="setIsCreateOpeningHours"
        @today="setToday"
        @next="setNext"
        @prev="setPrev">
      </DutySchedulePlan>
      <!-- TO CREATE -->
      <CreateEvent v-if="theCreateEventObj"
                   :openingHours="openingHours"
                   :user="theCreateEventObj.user"
                   :initDate="theCreateEventObj.date"
                   :initSubject="theCreateEventObj.subject"
                   :emitEvent="true"
                   @addANewEvent="onAddedEvent"
                   @close="onCloseCreateEvent">
      </CreateEvent>
      <!-- TO EDIT -->
      <CreateEvent v-if="theEditEventObj"
                   :user="theEditEventObj.user"
                   :editEvent="theEditEventObj.event"
                   :emitEvent="true"
                   :openingHours="openingHours"
                   @updatedEvent="onUpdatedEvent"
                   @deletedEvent="onDeletedEvent"
                   @close="onCloseCreateEvent">
      </CreateEvent>
      <CreateSubject v-if="theCreateSubjectCalendar"
                     :calendarAndUsers="theCreateSubjectCalendar"
                     :schoolId="schoolId"
                     :schoolYearId="schoolYearId"
                     @created="onNewSubjectCreated"
                     @close="onCreateSubject(null)">
      </CreateSubject>
      <DutyScheduleOpeningHours
        v-if="isCreateOpeningHours"
        :propOpeningHours="openingHours"
        @close="setIsCreateOpeningHours(false)">
      </DutyScheduleOpeningHours>
      <!--
      <BottomNav
        @today="setToday"
        @next="setNext"
        @prev="setPrev">
      </BottomNav>
      -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import WeekSelecter from '../datepicker/WeekSelecter.vue'
import docendo from '../../docendo'
import DutySchedulePlan from './DutySchedulePlan.vue'
import DoSplash from '../common/DoSplash.vue'
import DutyScheduleCalendar from './DutySchedulePlanCalendar.vue'
import CreateEvent from './CreateEvent/CreateEvent.vue'
import BottomNav from './BottomNav.vue'
import CreateSubject from './CreateSubject/CreateSubject.vue'
import DModal from '../common/DModal.vue'
import DutyScheduleOpeningHours from './DutyScheduleOpeningHours.vue'

export default {
  components: {
    DutyScheduleOpeningHours,
    DModal,
    CreateSubject, BottomNav, CreateEvent, DutyScheduleCalendar, DoSplash, DutySchedulePlan, WeekSelecter
  },
  data () {
    return {
      date: moment(),
      events: [],
      isEventsLoading: false,
      theCreateEventObj: null,
      theEditEventObj: null,
      userNorms: null,
      isLoadingUserNorms: false,
      theCreateSubjectCalendar: null,
      theNewlyCreatedSubject: null,
      isCreateOpeningHours: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    openingHours () {
      if (!this.schoolSettings || !this.schoolSettings.openingHours) {
        return null
      } else {
        return this.schoolSettings.openingHours
      }
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    schoolYearId () {
      return this.schoolYear && this.schoolYear.id ? this.schoolYear.id : null
    },
    calendars () {
      return this.$store.state.calendars
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    isLoadingAllUsers () {
      return this.$store.state.isLoadingAllUsers
    },
    isInitialLoading () {
      return this.isLoadingSchoolCalenders || this.isLoadingAllUsers || this.isSubjectsLoading
    },
    kindergartenCalendars () {
      return this.$store.getters.kindergartenCalendars
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    eventsInUserCalendarIdHash () {
      return this.events.reduce((eventsHash, event) => {
        const eventDate = moment(event.start).format('YYYY_MM_DD')
        const eventTimeFormatted = `${moment(event.start).format('HH:mm')} - ${moment(event.end).format('HH:mm')}`
        const eventObj = {
          ...event,
          v_time: eventTimeFormatted
        }
        event.calendars.forEach(calendar => {
          const lookUpKey = `${calendar.calendar_id}_${eventDate}`
          if (eventsHash[lookUpKey]) {
            eventsHash[lookUpKey].push(eventObj)
          } else {
            eventsHash[lookUpKey] = [eventObj]
          }
        })
        return eventsHash
      }, {})
    }
  },
  watch: {
    users () {
      this.readEvents()
    },
    schoolYear () {
      this.readUserNorm()
    }
  },
  methods: {
    setIsCreateOpeningHours (bool) {
      this.isCreateOpeningHours = bool
    },
    onNewSubjectCreated ($event) {
      this.onCreateSubject(null)
      this.theNewlyCreatedSubject = $event
    },
    onCreateSubject (calendarAndUsers) {
      this.theCreateSubjectCalendar = calendarAndUsers
    },
    onUpdatedEvent () {
      this.onCloseCreateEvent()
      this.readEvents()
    },
    onDeletedEvent () {
      this.onCloseCreateEvent()
      this.readEvents()
    },
    onCloseCreateEvent () {
      this.theCreateEventObj = null
      this.theEditEventObj = null
    },
    onAddedEvent (event) {
      this.theCreateEventObj = null
      this.readEvents()
    },
    onEditEvent (theEditEvent) {
      this.theEditEventObj = theEditEvent
    },
    onCreateEvent (theEventObject) {
      this.theCreateEventObj = theEventObject
    },
    setDate (date) {
      this.date = date
      this.readEvents()
    },
    setToday () {
      this.setDate(moment())
    },
    setPrev () {
      const date = moment(this.date).subtract(1, 'week')
      this.setDate(date)
    },
    setNext () {
      const date = moment(this.date).add(1, 'week')
      this.setDate(date)
    },
    readEvents () {
      const calendarIds = this.users.map(user => user.user_calendar_id)
      if (calendarIds.length === 0) {
        return
      }
      // this.isEventsLoading = true
      const start = moment(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00')
      const end = moment(this.date).isoWeekday(5).endOf('day')
      docendo.calendarEvents2(calendarIds, start, end, null,
        data => {
          this.events = data.length > 0 ? JSON.parse(data) : []
          this.isEventsLoading = false
        }, failure => {
          console.log('failure', failure)
        })
    },
    readUserNorm () {
      if (!this.schoolYear || !this.schoolId) {
        return
      }
      this.isLoadingUserNorms = true
      this.userNorms = null
      docendo.schoolUserYearsList(this.schoolId, this.schoolYear.id, null, success => {
        this.userNorms = success
        this.isLoadingUserNorms = false
      }, failure => {
        console.log('failed!')
      })
    }
  },
  mounted () {
    this.readEvents()
    this.readUserNorm()
  }
}
</script>

<style scoped>
/* Transition styles */
.fadeOut-leave-active {
  transition: opacity 1s ease;
}

.fadeOut-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// DutySchedule.vue?0a714408